var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_75_1",
    "data-name": "Component 75 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.905,
    height: 39.604,
    viewBox: "0 0 48.905 39.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17361",
    "data-name": "Path 17361",
    d: "M509.06,289.009l1.281-1.933,3.484,2.309-1.281,1.933Z",
    transform: "translate(-468.071 -267.113)",
    fill: "#b2b2c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17362",
    "data-name": "Path 17362",
    d: "M511.75,133l3.493-2.329,1.292,1.938-3.492,2.329Z",
    transform: "translate(-470.482 -126.969)",
    fill: "#b2b2c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17363",
    "data-name": "Path 17363",
    d: "M540.4,218.4h4.658v2.329H540.4Z",
    transform: "translate(-496.153 -205.577)",
    fill: "#b2b2c9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17364",
    "data-name": "Path 17364",
    d: "M142.14,132.621l1.292-1.938,3.493,2.329-1.292,1.938Z",
    transform: "translate(-139.298 -126.979)",
    fill: "#b2b2c9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17365",
    "data-name": "Path 17365",
    d: "M142.18,289.841l3.493-2.329,1.292,1.938-3.493,2.329Z",
    transform: "translate(-139.333 -267.504)",
    fill: "#b2b2c9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17366",
    "data-name": "Path 17366",
    d: "M114.8,218.4h4.658v2.329H114.8Z",
    transform: "translate(-114.8 -205.577)",
    fill: "#b2b2c9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17367",
    "data-name": "Path 17367",
    d: "M242.235,105.247a5.135,5.135,0,0,0-4.029-6.614,4.949,4.949,0,0,0-8.541-1.816,4.949,4.949,0,0,0-8.535,1.8,5.135,5.135,0,0,0-4.029,6.614,5.821,5.821,0,0,0,0,7.569,5.135,5.135,0,0,0,4.029,6.613,4.953,4.953,0,0,0,1.549,2.434v4.658A3.493,3.493,0,0,0,226.172,130v2.329a2.329,2.329,0,0,0,2.329,2.329h2.329a2.329,2.329,0,0,0,2.329-2.329V130a3.493,3.493,0,0,0,3.493-3.493v-4.658a4.958,4.958,0,0,0,1.549-2.381,5.135,5.135,0,0,0,4.029-6.613,5.822,5.822,0,0,0,0-7.569Zm-11.4,27.083H228.5V130h2.329Zm3.493-5.822a1.165,1.165,0,0,1-1.164,1.164h-6.987a1.164,1.164,0,0,1-1.164-1.164v-3.575a4.931,4.931,0,0,0,4.658-1.665,4.931,4.931,0,0,0,4.658,1.683Zm4.862-14.252.14.14h0a2.8,2.8,0,0,1-3.254,4.483v1.164a2.62,2.62,0,0,1-5.24,0v-1.432a1.164,1.164,0,0,1,1.164-1.164h1.811a1.1,1.1,0,0,0,1.1-1.1v-.122a1.1,1.1,0,0,0-1.1-1.106h-1.811a3.493,3.493,0,0,0-3.493,3.493v1.455a2.62,2.62,0,0,1-5.24,0V116.9a2.771,2.771,0,0,1-3.941-3.3,4.671,4.671,0,0,0,1.03.093h1.811a1.1,1.1,0,0,0,1.1-1.1v-.122a1.1,1.1,0,0,0-1.1-1.106h-1.811a2.329,2.329,0,0,1-2.329-2.329,3.493,3.493,0,0,1,2.125-3.214l-.14-.14a2.8,2.8,0,0,1,3.254-4.483v-1.164a2.62,2.62,0,0,1,5.24,0v.85a1.164,1.164,0,0,1-1.164,1.164h-1.811a1.1,1.1,0,0,0-1.1,1.1v.122a1.1,1.1,0,0,0,1.1,1.106h1.811a1.118,1.118,0,0,1,1.164,1.1v4.2a1.1,1.1,0,0,0,1.1,1.106h.122a1.1,1.1,0,0,0,1.106-1.1v-9.67a2.62,2.62,0,0,1,5.24,0v1.164a2.771,2.771,0,0,1,3.941,3.3,4.669,4.669,0,0,0-1.03-.093h-1.811a1.1,1.1,0,0,0-1.1,1.1v.122a1.1,1.1,0,0,0,1.1,1.106h1.811a2.329,2.329,0,0,1,2.329,2.329,3.493,3.493,0,0,1-2.125,3.213Z",
    transform: "translate(-205.214 -95.055)",
    fill: "#b2b2c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light_bulb.544d1123c0c45d61ec8654d43c932fdf.svg";
export { ForwardRef as ReactComponent };